import {getQuestionsWithOverrides, overrideQuestion} from "@irati/insights/services/question/v2"

/**
 * Action constants
 * @type {string}
 */
export const UPDATE_TENANT = "UPDATE_TENANT"
export const UPDATE_DRIVERS = "UPDATE_DRIVERS"
export const LOAD_QUESTIONS = "LOAD_QUESTIONS"
export const PUT_OVERRIDES = "PUT_OVERRIDES"
export const UPDATE_QUESTIONS = "UPDATE_QUESTIONS"
export const EDITING_QUESTION_ID = "EDITING_QUESTION_ID"

const actions = {}

/**
 * Update the store with the latest question list
 *
 * @param questions
 * @returns {{type: string, questions: *}}
 */
actions.updateTenant = (tenant) => {
  return {
    type: UPDATE_TENANT,
    tenant
  }
}

/**
 * Update the store with the driver list. Not used directly but used in concat functions in the reducer
 *
 * @param drivers
 * @returns {{type: string, drivers: *}}
 */
actions.updateDrivers = (drivers) => {
  return {
    type: UPDATE_DRIVERS,
    drivers
  }
}

/**
 * Update the store with the load promise for question lists
 *
 * @param questions
 * @returns {{type: string, questions: *}}
 */
actions.loadQuestions = (load) => {
  return {
    type: LOAD_QUESTIONS,
    loadQuestionsPromise: load
  }
}

/**
 * Update the store with the latest question list
 *
 * @param questions
 * @returns {{type: string, questions: *}}
 */
actions.updateQuestions = (questions) => {
  return {
    type: UPDATE_QUESTIONS,
    questions
  }
}

/**
 * Update the store with the latest question list
 *
 * @param questions
 * @returns {{type: string, questions: *}}
 */
actions.editingQuestionId = (questionId) => {
  return {
    type: EDITING_QUESTION_ID,
    questionId
  }
}

/**
 * Update the store with the put promise
 *
 * @param questions
 * @returns {{type: string, questions: *}}
 */
actions.putOverrides = (load) => {
  return {
    type: PUT_OVERRIDES,
    putOverridesPromise: load
  }
}

/**
 * THUNK action to fetch the questions, save the load promise to the store and then also the updated questions
 *
 * @param tenantId
 * @returns {function(*)}
 */
actions.fetchQuestions = (tenantId) => {
  return (dispatch) => {
    /** Fetch the questions, and dispatch the update */
    const load = getQuestionsWithOverrides(tenantId).then((questions) => dispatch(actions.updateQuestions(questions)))

    /** Set the load promise in the store */
    return dispatch(actions.loadQuestions(load))
  }
}

/**
 * THUNK action to override question text for a tenant:
 * - save the load promise to the store
 * - re-fetch the questions
 * - set editing question to null as it is no longer editing
 *
 * @param tenantId
 * @param question
 * @param text
 * @returns {function(*)}
 */
actions.overrideQuestionText = (tenantId, question, text) => {
  return (dispatch) => {
    /** Dispatch the update */
    const load = overrideQuestion(tenantId, question, text)
    /** Once complete re-fetch the questions */
    load.then(() => {
      /** When a new set of questions are loaded in, reset the editing state back to default */
      dispatch(actions.editingQuestionId(null))

      /** Return the fetch question dispatch */
      return dispatch(actions.fetchQuestions(tenantId))
    })

    /** Set the load promise in the store */
    return dispatch(actions.putOverrides(load))
  }
}

export const updateTenant = actions.updateTenant
export const updateDrivers = actions.updateDrivers
export const loadQuestions = actions.loadQuestions
export const updateQuestions = actions.updateQuestions
export const editingQuestionId = actions.editingQuestionId
export const putOverrides = actions.putOverrides
export const fetchQuestions = actions.fetchQuestions
export const overrideQuestionText = actions.overrideQuestionText

export default actions
